import { reject } from 'lodash';
import { Moment } from 'moment';
import { APPLICATION_ID } from '../../../shared/constants/commonConstants';
import { INVENTORY_SAVE_DOCTORS } from '../../../shared/constants/urlEndPoints';
import { DoctorDetails, Qualifications, QualificationsRequestObject, Week, WorkingSlots } from '../../../shared/models/inventory.model';
import SendRequest from '../../../shared/services/sendRequest.service';
import { error, getMinutesFromDate } from '../../../utils/utility';
import { INVENTROY_CONSTANTS } from './../../../shared/constants/commonConstants';

export const SaveDoctorDetails = (doctorDetails: DoctorDetails): Promise<any> => {
  const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_DOCTORS;
  const payload = {
    applicationId: APPLICATION_ID,
    doctorDetails: [doctorDetails],
  };
  return SendRequest.instance.post(url, payload);
};

export const UpdateDoctorDetails = (doctorDetails: DoctorDetails, week?: Week[]): Promise<any> => {
  const doctorDetail: DoctorDetails | any = doctorDetails ? {
    ...doctorDetails,
    professionalDetail: doctorDetails.professionalDetail && doctorDetails.professionalDetail.departmentId ? {
      ...doctorDetails.professionalDetail,
      qualifications: doctorDetails.professionalDetail.qualifications ?
        getQualifications(doctorDetails.professionalDetail.qualifications) : null,
    } : null,
    workingSlots: week ? getWorkingSlots(week) : doctorDetails.workingSlots,
    consultationDetail: doctorDetails.consultationDetail && doctorDetails.consultationDetail.consultationType ? {
      ...doctorDetails.consultationDetail,
    } : null,
  } : error(INVENTROY_CONSTANTS.noDataFound);
  if (doctorDetails) {
    reject('error');
  }
  return SaveDoctorDetails(doctorDetail);
};

const getQualifications = (qualification: Qualifications[]): QualificationsRequestObject[] => {
  const qualifications: QualificationsRequestObject[] | any = (qualification && qualification.length > 0) ?
    qualification.map((v: Qualifications): any => {
      return {
        qualificationName: v.qualificationName,
      };
    }) : null;
  return qualifications;
};

const getWorkingSlots = (weekSlots: Week[]): WorkingSlots[] => {
  const modifiedWorkingSlots: Week[] | any = (weekSlots && weekSlots.length) ? weekSlots.filter((day: Week): boolean =>
    (day.start !== undefined && day.slotsRanges && day.slotsRanges.length > 0)) : null;
  const workingSlots: WorkingSlots[] | any = (modifiedWorkingSlots && modifiedWorkingSlots.length > 0) ?
    modifiedWorkingSlots.map((workDay: Week): any => {
      const io = workDay.slotsRanges.map((vvv: Moment): any => {
        return {
          startTime: getMinutesFromDate(vvv[0]._d),
          endTime: getMinutesFromDate(vvv[1]._d),
        };
      });
      return {
        dayOfWeek: workDay.value,
        slots: io,
      };
    }) : null;
  return workingSlots;
};
